import styled, { css } from "styled-components";
import { COLORS } from "../../styles/constants.style";
import {
  fontWeightBold,
  textFieldTypographyH4Medium,
} from "../typography/MuiTypography.style";

const textFieldTypographyH5SemiBold = css`
  ${textFieldTypographyH4Medium};
  text-transform: none;
  text-align: center;
  padding: 16px 32px;
`;

export const MuiTabsWrapper = styled.div`
  .MuiTabs-root {
    border-bottom: 1px solid ${COLORS.cirrus_black3};

    .MuiButtonBase-root {
      color: ${COLORS.cirrus_black7};
      ${textFieldTypographyH5SemiBold};
    }

    .Mui-selected {
      color: ${COLORS.primary_dark_blue9};
      ${textFieldTypographyH5SemiBold};
      ${fontWeightBold};
      .selected-count {
        background-color: ${COLORS.primary_dark_blue9};
      }
    }

    .MuiTabs-indicator {
      color: ${COLORS.primary_dark_blue9};
      height: 5px;
    }
  }
  .selected-count {
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_black7};
    padding: 3px 6px;
    border-radius: 8px;
    margin-left: 8px;
    height: 26px;
  }
`;
